export const models = window['builderModelList'] || [
    {
      preview: '/build/images/base_render_1.png',
      manifest: process.env.REACT_APP_PATH + 'assets/tshirt2/manifest.json',
      poster: '/build/images/main_image.png',
      product: 't-shirt',
      description: 'Choose your colours, add your logos & customise each product with your gamertag, name & number.',
      price: "$60.00",
      start_color:["white"]
    },
    {
      preview: '/build/images/base_render_2.png',
      manifest: process.env.REACT_APP_PATH + 'assets/jacket/manifest.json',
      poster: '/build/images/main_image.png',
      product: 'jersey',
      description: 'Choose your colours, add your logos & customise each product with your gamertag, name & number.',
      price: "$160.00",
      start_color:["white"]
    },
    {
      preview: '/build/images/base_render_3.png',
      manifest: process.env.REACT_APP_PATH + 'assets/hoodie/manifest.json',
      poster: '/build/images/main_image.png',
      product: 'hoodie',
      description: 'Choose your colours, add your logos & customise each product with your gamertag, name & number.',
      price: "$60.00",
      start_color:["white"]
    },
    {
      preview: '/build/images/base_render_4.png',
      manifest: process.env.REACT_APP_PATH + 'assets/joggers/manifest.json',
      poster: '/build/images/main_image.png',
      product: 'joggers',
      description: 'Choose your colours, add your logos & customise each product with your gamertag, name & number.',
      price: "$460.00",
      start_color:["white"]
    },
    {
      preview: '/build/images/base_render_5.png',
      manifest: process.env.REACT_APP_PATH + 'assets/sleevs/manifest.json',
      poster: '/build/images/main_image.png',
      product: 'sleevs',
      description: 'Choose your colours, add your logos & customise each product with your gamertag, name & number.',
      price: "$260.00",
      start_color:["white"]
    },
    {
      preview: '/build/images/mouse.png',
      manifest: process.env.REACT_APP_PATH + 'assets/mousemat/manifest.json',
      poster: '/build/images/mouse_poster.png',
      product: 'mouse mat',
      description: 'Choose your mouse mat',
      price: "$120.00",
      start_color:["white"]
    },
  ];